<template>
    <el-aside class="aside-nav" :class="{ 'is-collapsed': collapsed }" :style="{width: collapsed?'60px':'220px'}">
        <div class="aside-nav-scroll">
            <aside-wrapper @click="collapsed=false">
                <slot></slot>
            </aside-wrapper>
        </div>
        <div class="footer">
            <div class="footer-left" @click.stop>
                <template v-if="collapsed">
                    <el-tooltip :content="versionTooltip" placement="top">
                        <el-icon class="footer-info-icon" :size="18">
                            <InfoFilled/>
                        </el-icon>
                    </el-tooltip>
                </template>
                <template v-else>
                    <el-tooltip :content="versionTooltip" placement="top">
                        <span class="version-text">{{ versionText }}</span>
                    </el-tooltip>
                </template>
            </div>
            <div class="footer-right" @click="collapsed = !collapsed">
                <el-icon class="footer-toggle-icon" :size="22">
                    <ArrowRight v-if="collapsed"/>
                    <ArrowLeft v-else/>
                </el-icon>
            </div>
        </div>
    </el-aside>
</template>

<script>
import AsideGroup from "./AsideGroup";
import AsideWrapper from "./AsideWrapper";
import AsideItem from "./AsideItem";
import {computed} from "vue";
import {ArrowLeft, ArrowRight, InfoFilled} from '@element-plus/icons-vue'

export default {
    name: "AsideNav",
    components: {AsideItem, AsideWrapper, AsideGroup, ArrowLeft, ArrowRight, InfoFilled},
    props: {data: Object},
    data() {
        return {
            collapsed: false,
            version: '',
        }
    },
    provide() {
        return {collapsed: computed(_ => this.collapsed), unCollapse: this.unCollapse, collapse: this.collapse}
    },
    methods: {
        collapse() {
            this.collapsed = true;
        },
        unCollapse() {
            this.collapsed = false;
        }
    },
    computed: {
        versionText() {
            const raw = (this.version || '').replace(/\"/g, '').replace(/"/g, '').trim();
            const ts = Number(raw);
            if (ts && !isNaN(ts)) {
                const d = new Date(ts);
                return `${d.toLocaleString()}`;
            }
            return '开发版';
        },
        versionTooltip() {
            return `系统更新时间：${this.versionText}`;
        }
    },
    mounted() {
        fetch('version.json', {cache: 'no-store'})
            .then(res => res.ok ? res.text() : Promise.reject('no version'))
            .then(text => { this.version = text; })
            .catch(() => { this.version = 'dev'; });
    }
}
</script>

<style scoped>
.aside-nav {
    transition: width 0.3s ease;
    overflow: hidden;
}
.aside-nav-scroll {
    height: calc(100% - 41px);
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--el-border-color) transparent;
}
.aside-nav-scroll::-webkit-scrollbar {
    width: 6px;
}
.aside-nav-scroll::-webkit-scrollbar-thumb {
    background-color: var(--el-border-color);
    border-radius: 3px;
}
.aside-nav-scroll::-webkit-scrollbar-track {
    background: transparent;
}
.aside-nav .footer {
    font-size: 18px;
    border-top: 1px solid var(--el-border-color);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.footer-info-icon {
    margin: 9px 4px 9px 10px;
}
.footer-toggle-icon {
    margin: 9px 10px 9px 0;
}
.is-collapsed .footer-info-icon {
    margin: 9px 0 9px 8px;
}
.is-collapsed .footer-toggle-icon {
    margin: 9px 8px 9px 0;
}
.footer-left {
    cursor: default;
}
.footer-right {
    cursor: pointer;
}
.version-text {
    display: inline-block;
    margin: 9px 12px;
    font-size: 12px;
    color: var(--el-text-color-secondary);
    white-space: nowrap;
    max-width: calc(220px - 60px);
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
